<template>
	<div>
		<div v-for="(item, index) in items" :key="index" v-if="filterItems(item.amountType)">
			<v-divider v-if="items.length"></v-divider>
			
			<div class="items-wrapper">
				<v-list two-line full-width nopadding>

				    <v-list-tile class="accountbook-tile">
			          	<v-list-tile-content>
			              <!-- <v-list-tile-title>{{item.accountLedgerName}}</v-list-tile-title> -->
			              <v-list-tile-title @click="fn_accountDetails(item)">
			              		<div class="account-name">{{item.accountLedgerName}}&nbsp;</div>
			              </v-list-tile-title>

			              <v-list-tile-sub-title v-if="item.refNumber">Ref No: {{item.refNumber}}</v-list-tile-sub-title>

			              <v-list-tile-sub-title>
			              	<!-- Balance:  -->
							<span light-opacity-color v-if="$root.appVersion >= 136">{{ $parent.fn_balanceLabel(item) }}</span>
							<span v-else>Balance:</span>
			              	<span :class="[item.currentBalance < 0 ? 'redcolor' : 'greencolor']">&#8377; {{$root.numberToLocale(item.currentBalance)}}</span>
			              </v-list-tile-sub-title>
			              <!-- <v-list-tile-sub-title>{{fn_processedBalance(item.currentBalance, item.currentBalanceType)}}</v-list-tile-sub-title> -->
			            </v-list-tile-content>

			            <v-list-tile-action>
			            	<div>&#8377; {{$root.numberToLocale(item.itemAmount ? item.itemAmount : $parent.displayData.amount)}}</div>
			            	<v-btn flat icon></v-btn>
			            </v-list-tile-action>
				    </v-list-tile>

				    <v-expansion-panel 
				    	class="reference-panel" 
				    	v-if="item.references && item.references.length" v-model="item.expansionPanelModel" expand>

					    <v-expansion-panel-content>
					      <div slot="header" class="reference-header">Linked Invoice(s)</div>
					      <v-card>
					        <v-card-text>

					        	<div class="card-items" v-if="item.onAccount">
					        	 	On Account
					        	 	<v-spacer></v-spacer>
					        	 	<span>&#8377; {{$root.numberToLocale(item.onAccount)}}</span>
					        	</div>

					        	<div v-for="(ref, refIndex) in item.references" :key="refIndex"
					        	 class="card-items" v-if="ref.isAgainstRef">
					        	 	<!-- {{ref.prefix}}/{{ref.baseTransactionNumber}}{{ref.suffix ? '/'+ref.suffix : ''}} -->
					        	 	<!-- {{ref.baseTransactionNumber}} -->
					        	 	<span v-if="ref.baseTransactionNumber">{{ref.baseTransactionNumber}}</span>
					        	 	<span v-else>{{ref.baseRefNumber ? ref.baseRefNumber : ''}}</span>&nbsp;
					        	 	
					        	 	<v-spacer></v-spacer>
									 {{ $parent.fn_getPrefix(ref.transactionListId) == 'minus' ? '(-)' : '' }}
					        	 	<span>&#8377; {{$root.numberToLocale(ref.amount)}}</span>
					        	</div>

					        	<!-- <div class="card-items" v-if="item.references.length && item.amount!=null && item.amount!=''">
					        	 	On Account
					        	 	<v-spacer></v-spacer>
					        	 	<span>&#8377; {{$root.numberToLocale(item.amount)}} {{item.amountType ? 'Dr' : 'Cr'}}</span>
					        	</div> -->
					        </v-card-text>
					      </v-card>
					    </v-expansion-panel-content>
					</v-expansion-panel>

					<!-- <v-expansion-panel class="reference-panel" v-model="expandOtherDetails" expand v-if="item.amountType != selectedNatureValue && (item.bankName || item.transType || item.refNumber || item.refDate)">

					    <v-expansion-panel-content>
					      <div slot="header" class="reference-header">Other Details</div>
					      <v-card>
					        <v-card-text>

								<div class="card-items">
					        	 	Bank Name
					        	 	<v-spacer></v-spacer>
					        	 	<span>{{item.bankName ? item.bankName : '-'}}</span>
					        	</div>

					        	<div class="card-items">
					        	 	Type
					        	 	<v-spacer></v-spacer>
					        	 	<span>{{item.transType ? item.transType : '-'}}</span>
					        	</div>

					        	<div class="card-items">
					        	 	Ref Number
					        	 	<v-spacer></v-spacer>
					        	 	<span>{{item.refNumber ? item.refNumber : '-'}}</span>
					        	</div>

					        	<div class="card-items">
					        	 	Ref Date
					        	 	<v-spacer></v-spacer>
					        	 	<span v-if="item.refDate">{{item.refDate | moment("DD-MMM-YYYY")}}</span>
					        	 	<span v-else>-</span>
					        	</div>

					        </v-card-text>
					      </v-card>
					    </v-expansion-panel-content>

					</v-expansion-panel> -->

				</v-list>
			
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props:['items', 'showAll', 'showDebitItems', 'showCreditItems', 'selectedNatureValue'],
		methods:{
			filterItems: function (amountType) {
				if(this.showAll){
					return true;
				}
				else if(this.showDebitItems && amountType==1){
					return true;
				}
				else if(this.showCreditItems && amountType==0){
					return true;
				}
				else{
					return false;
				}
			},

			fn_accountDetails: function(item){
				this.$router.push('/masters/accounts/ledgers/items/'+item.accountLedgerId);
			}
			// fn_processedBalance: function(balance, balanceType){
			// 	let partyBal = this.$root.numberToLocale(this.roundUpto2Decimals(balance));
			// 	let balanceString = 'Current Bal: ₹ '+ partyBal;
			// 	if(balanceType==1){
			// 		balanceString = balanceString+' Dr';
			// 	}
			// 	else if(balanceType==0){
			// 		balanceString = balanceString+' Cr';
			// 	}

			// 	return balanceString;
			// },
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/accountbooks/dialogs/trans_display.vue